import React, { useEffect, useState } from 'react'
import dashlogo from '../images/dashboard_logo.png'
import { Link } from 'react-router-dom'
import $ from 'jquery'

export default function Topbar({ toggleSidebar }) {
    const [notifications, setNotifications] = useState([]);
    const [membretype, setMembertype] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);

    const darkColors = [
        "#4975c9ff", "#937509ff", "#8c1b72ff", "#5a64cfff", "#403F4C",
        "#934fe0ff", "#e3550fff", "#2C3641", "#3e886eff", "#37474F",
        "#0d7a93ff", "#d40ebdff", "#59801aff", "#684239ff", "#424242",
        "#158dc5ff", "#0d4b08ff", "#587482ff", "#de0f0fff", "#5D4037"
    ];
    const [permissions, setPermissions] = useState([]);
    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        const storedPermissions = JSON.parse(localStorage.getItem('user_permissions')) || [];
        setPermissions(storedPermissions);
        var adminmember = localStorage.getItem('user_position');
        if (adminmember === 'Member' || adminmember === 'manager') {
            $('.adminuse').css('display', 'none')
        }
        let memname = localStorage.getItem('memberFirstname');
        const letter = getFirstLetter(memname);
        const bgColor = getRandomDarkColor();
        $('#usertext').text(letter);
        $('#usertext').css('background-color', bgColor);


    }, []);

    useEffect(() => {
        const user_id = localStorage.getItem('member_id');

        function loadNotifications() {
            fetch('getNotifications.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ user_id })
            })
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data)) {
                        setNotifications(data);
                    }
                })
                .catch(err => console.error(err));
        }

        loadNotifications();

        const interval = setInterval(loadNotifications, 5000); // every 5 sec

        return () => clearInterval(interval);
    }, []);

    function toggleNotification() {
        setShowDropdown(prev => !prev);
    }

    function openNotification(item) {
        // mark notification as read
        fetch('makeNotificationAsRead.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: item.id
            })
        });
        // ==========================
        // MEETING NOTIFICATION
        // ==========================
        if (item.type === 'meeting') {
            if (item.target_link) {
                window.open(
                    item.target_link,
                    '_blank'
                );
            }
        }
        // ==========================
        // PROJECT CHAT
        // ==========================
        else if (item.type === 'chat') {
            localStorage.setItem('selected_project_id', item.target_id);
            localStorage.setItem('initialpage', 'communication');
            localStorage.setItem('active_conversation_id', item.ref_id);
            window.location.href = '/project_details';
        }

        // ==========================
        // TASK
        // ==========================

        else if (item.type === 'task') {
            console.log("Task notification");
        }
        // ==========================
        // PROJECT
        // ==========================
        else if (item.type === 'project') {
            console.log("Project notification");
        }

        // ==========================
        // DEFAULT
        // ==========================

        else {
            console.log("Unknown notification type");
        }

    }


    function getFirstLetter(name) {
        if (!name) return "";
        return name.trim().charAt(0).toUpperCase();
    }

    function getRandomDarkColor() {
        return darkColors[Math.floor(Math.random() * darkColors.length)];
    }


    const openclosemenu = () => {
        let usericon = document.getElementById('usericon');
        let dropdown = document.querySelector('.vl_dsh_one_drpdown_menu');
        if (dropdown.style.display === 'none') {
            dropdown.style.display = 'block';
            usericon.style.transform = 'rotate(180deg)';
        }
        else {
            dropdown.style.display = 'none';
            usericon.style.transform = 'rotate(0deg)';
        }

    }

    function navigatetosubscription() {
        let com_id = localStorage.getItem('mem_company_id');
        window.open("subscription.php?com=" + com_id, "_blank", "noopener,noreferrer");
    }
    return (
        <div>
            <div className='vl_dsh_topbar'>
                <div className='vl_dsh_container'>
                    <div className='vl_dsh_one_half'>
                        <div className='vl_dsh_one_menucollaps' onClick={toggleSidebar}>
                            <span>&nbsp;</span>
                            <span>&nbsp;</span>
                            <span>&nbsp;</span>
                        </div>
                        <div className='vl_dsh_one_dashboard_logo'><img src={dashlogo} /></div>
                    </div>
                    <div className='vl_dsh_one_half'>
                        <div className='vl_dsh_one_usertools'>

                            <span className='vl_dsh_one_tool_span handcursor' onClick={openclosemenu}>
                                <span ><i className='ri-arrow-down-s-fill' id="usericon" style={{ transform: 'rotate(180deg)' }}></i>
                                    <span className='usericon' id="usertext">S</span>
                                </span>
                                <div className='vl_dsh_one_drpdown_menu' style={{ display: 'none' }}>
                                    <ul>
                                        <li><Link to='/userprofile'><span><i className='ri-user-fill'></i></span> Profile</Link></li>
                                        {permissions.includes("settings.manage") && (
                                            <li className='adminuse'><Link to='/company_setting'><span><i className='ri-settings-4-fill'></i></span> Settings</Link></li>
                                        )}

                                        <li><Link to='/my_workhistory'><span><i className='ri-government-fill'></i></span> My Work History</Link></li>
                                        <li><Link to='/my_activity'><span><i className='ri-time-fill'></i></span> Activity & Timetable</Link></li>
                                        <li><Link to='/review'><span><i className='ri-time-fill'></i></span> Give Us Review</Link></li>
                                        <li><Link to='/logout'><span><i className='ri-logout-box-fill'></i></span> Logout</Link></li>
                                    </ul>
                                </div>
                            </span>

                            <span className='vl_dsh_one_tool_span tooltip' data-tooltip="Notifications">

                                <span onClick={toggleNotification} style={{ position: 'relative', cursor: 'pointer' }}>
                                    <i className='ri-notification-3-fill'></i>

                                    {/* 🔴 Count badge */}
                                    {notifications.length > 0 && (
                                        <span style={{
                                            position: 'absolute',
                                            top: '-5px',
                                            right: '-8px',
                                            background: 'red',
                                            color: '#fff',
                                            borderRadius: '50%',
                                            padding: '0px 5px',
                                            fontSize: '10px'
                                        }}>
                                            {notifications.length}
                                        </span>
                                    )}
                                </span>

                                {/* 📩 Dropdown */}
                                {showDropdown && (
                                    <div style={{
                                        position: 'absolute',
                                        right: '0',
                                        top: '40px',
                                        width: '300px',
                                        background: '#fff',
                                        border: '1px solid #ddd',
                                        borderRadius: '6px',
                                        zIndex: 999
                                    }}>
                                        <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                                            {notifications.length === 0 && (
                                                <li style={{ padding: '10px' }}>No notifications</li>
                                            )}

                                            {notifications.map((item, index) => (
                                                <li key={index}
                                                    style={{ padding: '10px', borderBottom: '1px solid #eee', cursor: 'pointer' }}
                                                    onClick={() => openNotification(item)}
                                                >
                                                    <strong>{item.title}</strong>
                                                    <p style={{ fontSize: '12px', margin: 0 }}>{item.message}</p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </span>


                            <span className='vl_dsh_one_tool_span tooltip' data-tooltip="Help Center"><span><i className='ri-question-line'></i></span></span>
                            {membretype && (
                                <span className='vl_dsh_one_tool_span tooltip upgradebtn' data-tooltip="Upgrade Membership"><span><button onClick={navigatetosubscription}>Upgrade</button></span></span>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
